import Vue from 'vue';
import BLNativeBridge from './BLNativeBridge/index';

Vue.use(BLNativeBridge);
